<header>
    <app-header head
                [attr.inert]="inertHeader$ | async"></app-header>
</header>
<div page
     [attr.inert]="inert$ | async">
    <router-outlet></router-outlet>
</div>
<footer>
    <app-footer foot
                [attr.inert]="inert$ | async"></app-footer>
</footer>
<overlay [attr.inert]="inertInvert$ | async"></overlay>
<layout-fab-outlet [attr.inert]="inert$ | async"></layout-fab-outlet>
<app-notification-outlet></app-notification-outlet>
